<template>
  <ul>
    <li v-if="cancel">
      <ButtonBase
        stroke="n"
        size="small"
        theme="secondary"
        variant="outlined"
        rounded
        @click="emit('cancel')"
      >
        {{ buttonCancel }}
      </ButtonBase>
    </li>
    <li v-if="confirm">
      <ButtonBase
        stroke="n"
        size="small"
        theme="secondary"
        rounded
        :disabled="!enable"
        @click="emit('confirm')"
      >
        {{ buttonConfirm }}
      </ButtonBase>
    </li>
  </ul>
</template>
<script lang="ts" setup>
interface Props {
  cancel?: boolean;
  confirm?: boolean;
  buttonConfirm?: string;
  buttonCancel?: string;
  enable?: boolean;
}
defineProps({
  cancel: { type: Boolean, default: true },
  confirm: { type: Boolean, default: true },
  buttonConfirm: { default: 'ok' },
  buttonCancel: { default: 'annuler' },
  enable: { type: Boolean, default: true }
});
const emit = defineEmits(["cancel", "confirm"]);
</script>
<style lang="scss" scoped>
ul {
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  justify-content: space-between;
  gap: 2rem;
  li {
    flex: 2 0 auto;
  }
  button {
    width: 100%;
  }
}
</style>
